import { render, staticRenderFns } from "./MentorSideBar.vue?vue&type=template&id=edb79592&"
import script from "./MentorSideBar.vue?vue&type=script&lang=js&"
export * from "./MentorSideBar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.less?vue&type=style&index=0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports